import { render } from "./CourseSkeleton.vue?vue&type=template&id=78b3b4cc"
import script from "./CourseSkeleton.vue?vue&type=script&lang=js"
export * from "./CourseSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__